"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductKindLimit = exports.productKindLimitSchema = void 0;
var yup = require("yup");
exports.productKindLimitSchema = yup.object().shape({
    amount: yup.number().required(),
    name: yup.string().required(),
    description: yup
        .object()
        .shape({
        en: yup.string().required(),
    })
        .required(),
});
function isProductKindLimit(obj) {
    return exports.productKindLimitSchema.isValidSync(obj);
}
exports.isProductKindLimit = isProductKindLimit;
